import React, { useEffect, useState } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Cookies from "universal-cookie";
import "./Styles/mailConfirmation.css"
import loader from "../Images/confirmation-loader.gif"
import {
    addProductInCart,
    addProductInFavourites,
    setCart,
    setCartID,
  } from "../Services/localStorage";
import moment from "moment/moment";

export const MailConfirmation = () => {

    const [content, setContent] = useState('');

    useEffect(() => {
        document.title = "Confirmation du mail - KabaaShop"

        const queryParameters = new URLSearchParams(window.location.search);

        var token = queryParameters.get("token");
        const cookies = new Cookies();

        if (token == null) {
            if(!cookies.get('user_temp')){
                window.location.href = '/';
            }

            axios.post(process.env.REACT_APP_API_BASE_URL + '/services/email/sendToUser?type=MailConfirmation',{},
            {
                headers: {
                    'x-api-token': cookies.get('user_temp').setToken,
                }
            }).then(a => {
                setContent(
                    <>
                        <h1 className="mail-confirmation-title">
                            Nous avons envoyé un mail de confirmation à l'adresse
                        </h1>
                        <h2 className="mail-confirmation-subtitle">
                            {a.data.sentTo}
                        </h2>
                    </>
                )
            }).catch(error => {
                toast.error('Une erreur est survenue');
            })
        }
        else {
            if (!cookies.get('user_temp') || cookies.get('user_temp').setToken !== token) {
                toast.error('Une erreur est survenue');
            }
            else {
                axios.patch(process.env.REACT_APP_API_BASE_URL + '/api/users/' + cookies.get('user_temp').id,
                    {
                        mailConfirmedAt: new Date()
                    }, {
                    headers: {
                        'x-api-token': process.env.REACT_APP_API_TOKEN,
                    }
                }).then(a => {
                    cookies.set("user", cookies.get('user_temp'), { path: "/", expires: moment().add(1, 'months').toDate()});
                    cookies.remove('user_temp')

                    if(cookies.get('cart_temp')){
                        setCartID(cookies.get('cart_temp').id);
                        cookies.get('cart_temp').orderedProducts.forEach((op) => {
                            addProductInCart(op.product, op.quantity);
                        });

                        cookies.remove('cart_temp')
                    }

                    toast.success('Votre adresse a bien été confirmée ! Vous serez redirigé dans un instant !')
    
                    setTimeout(() => {
                        window.location.href = '/';
                    }, 2500)
                }).catch(error => {
                    toast.error('Une erreur est survenue');
                })
            }
        }

    }, [true])

    return (
        <>
            <ToastContainer />
            <div className="mail-confirmation-page">
                
                <p>
                    <img src={loader} alt="loading"/>
                </p>
        
                {content}

                <a href="/">Retour à l'accueil</a>
        
            </div>
            
        </>
    );
};
